export default "__VITE_ASSET__1eqwDgAR__"